import scrollTop from './scrolltop/reducer.js';
import fullLoading from './loading/reducer.js';
import ajaxData from './ajax/reducer.js';

function loginUser(state = {}, action) {
    return state;
}

var rootReducer = {
    scrollTop,
    fullLoading,
    loginUser,
    ajaxData
};

export default rootReducer;



// WEBPACK FOOTER //
// ./components/redux/reducer.js